module.exports = __webpack_public_path__ + "img/log-file-icon.658bbb60.svg";